import { createModel } from '@rematch/core';
import { languagesService } from 'src/config/rootService';
import { RootModel } from 'src/config/rootStore';

import { Language } from '../models/language';

export type LanguageState = Language[] | null; // null is used as a isFetching flag

const defaultState = null as LanguageState;

export const languages = createModel<RootModel>()({
    state: defaultState,
    reducers: {
        saveLanguages: (_state, payload: Language[] = []): LanguageState => payload,
    },
    effects: dispatch => ({
        async fetchLanguages(_?: undefined, store?): Promise<void> {
            const languagesData = store.authentication.isAuthenticated
                ? await languagesService.fetchTranslatedLanguages()
                : await languagesService.fetchLanguages();

            if (languagesData) {
                languagesData.map(language => {
                    language.value = language.name;
                    language.text = language.displayName;
                });

                dispatch.languages.saveLanguages(languagesData);
            }
        },
    }),
});
